import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import axios from 'axios';
import PageHero from '../../components/PageHero';
import './NewsPage.css';
import newsHeroImg from '../../Assets/Image/News.webp';
import { newsItems as defaultNewsItems } from '../../data/newsData';
import SEO from '../../components/SEO';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

function resolveImageUrl(url) {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${API_BASE_URL}${url}`;
}

const NewsPage = () => {
  const [items, setItems] = useState(defaultNewsItems);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/news/section-cards`);
        if (Array.isArray(res.data.cards) && res.data.cards.length > 0) {
          setItems(res.data.cards);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchNews();
  }, []);

  return (
    <div className="news-page">
      <SEO
        title="News"
        description="Latest updates, announcements, and insights from Whales Advisory."
        canonicalPath="/news"
        type="website"
      />
      <PageHero title="News" imagePath={newsHeroImg} />

      <motion.section
        className="news-gallery-section"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        <div className="container">
          <div className="news-gallery-grid">
            {items.map((item) => {
              const imageSrc = resolveImageUrl(item.heroImage);
              return (
                <Link
                  key={item.id}
                  to={`/news/${item.id}`}
                  className="news-gallery-card-link"
                >
                  <article className="news-gallery-card">
                    <div className="news-gallery-image-container">
                      <img
                        src={imageSrc || item.heroImage}
                        alt={item.title}
                        className="news-gallery-image"
                      />
                    </div>
                    <div className="news-gallery-content">
                      <p className="news-gallery-date">{item.date}</p>
                      <h3 className="news-gallery-title">{item.title}</h3>
                      <p className="news-gallery-summary">{item.summary}</p>
                      <span className="news-gallery-read-more">
                        Read More →
                      </span>
                    </div>
                  </article>
                </Link>
              );
            })}
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default NewsPage;
